import translations from './translations'

translations.add('es', {
    yourKlarnaPaymentUnsuccessful: 'El pago de Klarna no se ha realizado correctamente. Por favor, inténtelo de nuevo más tarde'
})
